export const _LOAD_MODEL_ = 'Load:Distributor';
export const _DELETE_DISTRIBUTOR_ = 'Delete:Distributor';
export const _EDIT_DISTRIBUTOR_ = 'Save:DistributorSuccess';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_DISTRIBUTOR_SUCCESS_ = 'Save:DistributorSuccess';
export const _UPDATE_DISTRIBUTOR_STATUS_ = 'Update:DistributorStatus';

export const ATTACHED = 'attached';
export const DETACHED = 'detached';

export const ADDRESS = {
  id: null,
  city: '',
  label: 'Endereço Principal',
  state: '',
  number: '',
  street: '',
  address: '',
  country: 'BR',
  zipcode: '',
  address2: null,
  district: '',
};

export const REGIONS = {
  coversEntireState: false,
  whole_states: [],
};

export const MODEL = {
  id: null,
  name: '',
  email: '',
  phone: '',
  cellphone: null,
  whole_states: [],
  regional: null,
  social_medias: {
    facebook: null,
    instagram: null,
  },
  responsible: null,
  direct_sales: false,
  supervisor_id: null,
  address: { ...ADDRESS },
};
